// extracted by mini-css-extract-plugin
export default {"topContainer":"PatientPreconfigHeader_topContainer__BxlNW","unlink":"PatientPreconfigHeader_unlink__jIaYP"};